// @flow

import { combineReducers } from 'redux-immutable';

import noticia from 'reducers/ferramentas/noticia';
import prestador from 'reducers/ferramentas/prestador';

export default combineReducers({ noticia, prestador });
